<template>
<div class="chapter">
<div class="inner_page">
<h1>House of Windows</h1>
<h3 class="sigil_not_in_toc">John Langan</h3>
<h4 class="sigil_not_in_toc" style="text-align: center;">Introduction by Adam Nevill</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM1_TitlePage.vue?64692782